module.exports = __webpack_public_path__ + "a261a182ed0af2fe60d902221b69faf7.svg";